import type { JSX } from "react";

import { Route, Routes } from "react-router-dom";
import Add from "./Add";
import Document from "./Document";
import Documents from "./Documents";
import Edit from "./Edit";
import LoadSearch from "./LoadSearch";

function DocumentRoutes(): JSX.Element {
    return (
        <Routes>
            <Route path="add" element={<Add />} />
            <Route path="search" element={<LoadSearch />} />
            <Route path=":documentId" element={<Document />} />
            <Route path=":documentId/edit" element={<Edit />} />
            <Route index element={<Documents />} />
        </Routes>
    );
}

export default DocumentRoutes;
